// JHUBA: DA AGGIORNARE CON DATI DI SUITEDREAMS-TEST
import env from './.env.json';
import rel from './.rel.json';

export const environment = {
    env: 'test',
    test: true,
    production: false,
    version: env.npm_package_version + ' (test)',
    build: rel.release,
    serverUrl: '',
    defaultLanguage: 'it-IT',
    supportedLanguages: [
        'it-IT',
        'en-GB'
    ],
    configFirebase: {
        apiKey: 'AIzaSyAfMOdGkeX6ymfQjq-KVNliEuVtiLc0MkE',
        authDomain: 'suitedreams-test.firebaseapp.com',
        projectId: 'suitedreams-test',
        storageBucket: 'suitedreams-test.appspot.com',
        messagingSenderId: '471391280208',
    },
    firebaseClientId: '471391280208-m6ituhv6g7864kib8pf4olgq3vjt8arr.apps.googleusercontent.com',
    scope: 'email profile'
};
